<template>
    <section class="padding-vertical-content lightgray-content mb-3 mb-lg-4">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="nombre">{{$t("formularios.nombre_completo") + " *"}}</label>
                                    <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
                                        <input
                                            data-cy="nombre"
                                            id="nombre"
                                            type="text"
                                            :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                            :placeholder="$t('formularios.nombre_completo')"
                                            v-model="acreditacion_local.nombre"
                                        />
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <DocumentoTipo
                                    v-model="acreditacion_local.tipoDocumento"
                                    :index="0"
                                />
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <DocumentoValor
                                    data-cy="dni"
                                    v-model="acreditacion_local.dni"
                                    :type="acreditacion_local.tipoDocumento"
                                    :index="0"
                                />
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="email">{{$t("formularios.email") + " *"}}</label>
                                    <ValidationProvider name="email" rules="required" v-slot="{ errors }">
                                        <input id="email" type="text" :class="
                                            'form-control ' + (errors[0] ? 'is-invalid' : '')
                                        " :placeholder="$t('formularios.email')" v-model="acreditacion_local.email"
                                        />
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="telefono">{{$t("formularios.telefono") + " *"}}</label>
                                    <ValidationProvider name="telefono" rules="required" v-slot="{ errors }">
                                        <input id="telefono" type="text" :class="
                                            'form-control ' + (errors[0] ? 'is-invalid' : '')
                                        " :placeholder="$t('formularios.telefono')" v-model="acreditacion_local.telefono"
                                        />
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="medio">{{$t("formularios.medio") + " *"}}</label>
                                    <ValidationProvider name="medio" rules="required" v-slot="{ errors }">
                                        <input id="medio" type="text" :class="
                                            'form-control ' + (errors[0] ? 'is-invalid' : '')
                                        " :placeholder="$t('formularios.medio')" v-model="acreditacion_local.medio"
                                        />
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="funcion">{{$t("formularios.funcion") + " *"}}</label>
                                    <ValidationProvider name="funcion" rules="required|max:20" v-slot="{ errors }">
                                        <input id="funcion" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.funcion')" v-model="acreditacion_local.funcion"/>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="evento">{{$t("formularios.seleciona_el_evento") + " *"}}</label>
                                    <ValidationProvider name="evento" rules="required" v-slot="{ errors }">
                                        <multiselect
                                            v-model="event"
                                            :options="eventos"
                                            :multiple="false"
                                            :close-on-select="true"
                                            :clear-on-select="false"
                                            :preserve-search="true"
                                            placeholder="Seleccione el evento"
                                            label="name"
                                            track-by="id"
                                            id="slect-evento"
                                            :class="
                                                ' ' + (errors[0] ? 'is-invalid' : '')
                                            "
                                        />
                                        <span v-if="errors[0]" class="error invalid-feedback is-invalid" style="display: block;">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <button type="submit" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" id="terminar">
                                <span>{{ $t('formularios.continuar') }}</span>
                            </button>
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import DocumentoTipo from '@/components/common/DocumentoTipo.vue';
    import DocumentoValor from '@/components/common/DocumentoValor.vue';

    export default {
        props: {
            esMovil: {
                type: Boolean,
                default: false
            },
            events: {
                type: Object,
                default: () => {}
            },
            acreditacion: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                eventos: [],
                event: {},
                acreditacion_local: { ...this.acreditacion },

            };
        },
        created() {
            if (!this.acreditacion_local.tipoDocumento) {
                this.$set(this.acreditacion_local, 'tipoDocumento', 'DNI');
            }
            this.getEventos();
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.acreditacion_local.evento_id = this.event.id
                    this.$emit('submit', this.acreditacion_local);
                }
            },
            getEventos() {
                let params = {filters: {tid : this.configuracion.hash_teatro}};

                this.$store.dispatch(this.config.getVuexAlias('front.events.select'), params).then(res => {
                    this.eventos = res.data.data;
                })
            },
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        components:{
            DocumentoTipo, DocumentoValor
        }
    };
</script>
